import { createContext, useContext } from "react";

interface CartPageContextProps {
  disableCheckout: boolean;
  showSubtotal: boolean;
}

const CartPageContext = createContext<CartPageContextProps>({
  disableCheckout: true,
  showSubtotal: true,
});

export const CartPageContextProvider = CartPageContext.Provider;
export const useCartPageContext = () => useContext(CartPageContext);
